export default __webpack_public_path__ + "static/media/logo2.79ef0d3b.png";